export const ACCORDION = 'Accordion';
export const ACCORDION_ITEM_CONTENT = 'Accordion Item Content';
export const ACTIVE_VIEWER = 'Active Viewer';
export const BRAND_BANNER = 'Brand Banner';
export const COPY_ONLY_TILE = 'Copy Only';
export const CONTENT_HEADER = 'Content Header';
export const DYNAMIC_CONTAINER = 'Dynamic Container';
export const EXPERIMENT = 'Experiment';
export const FIT_GUIDE_CONTAINER = 'Fit Guide Container';
export const FIT_VIDEO_CONTAINER = 'Fit Video Container';
export const FOOTER_LINKS = 'Footer Links';
export const GLOBAL_FOOTER_BANNER_GROUP = 'Global Footer Banner Group';
export const GLOBAL_HEADER_COPY = 'Global Header Copy';
export const GLOBAL_HEADER_COPY_GROUP = 'Global Header Copy Group';
export const GLOBAL_MESSAGING = 'Global Messaging';
export const GLOBAL_MESSAGING_BANNER_GROUP = 'Global Messaging Banner Group';
export const HEADER_FILTER_BELOW = 'InteractiveHeader';
export const HEADER_FILTER_BELOW_QUIZ = 'InteractiveHeaderMulti';
export const HTML_BLOCK = 'HTML Block';
export const IFRAME = 'iFrame';
export const IMAGE_WITH_ROUTE = 'Image with Route';
export const PDP_COPY_STRINGS = 'PDP Copy Strings';
export const PERSONALIZED_HP_TILE = 'Personalized HP Tile';
export const PRODUCT_RECOMMENDATIONS_SHELF = 'Recommendations 3.0';
export const PROMO_TILE = 'Promo Tile';
export const RANKED_RESULTS = 'Ranked Results';
export const RESPONSIVE_CAROUSEL = 'Responsive Carousel';
export const RESPONSIVE_CAROUSEL_APP = 'Responsive Carousel - App';
export const RESPONSIVE_STAGGERED_GROUP = 'Responsive Staggered Group';
export const SEO_CONTENT_BLOCK = 'SEO Content Block';
export const SIZE_CHART_CONTAINER = 'Size Chart Container';
export const SIZE_FIT_COPY = 'Size Fit Copy';
export const SIZE_FIT_IMAGES = 'Size Fit Images';
export const SIZE_FIT_TABLE = 'Size Fit Table';
export const SIZE_FIT_TABLE_GROUP = 'Size Fit Table Group';
export const SIZE_FIT_VIDEO = 'Size Fit Video';
export const STORY_CAROUSEL = 'Story Carousel';
export const TAB = 'Tab';
export const TAB_ITEM_CONTENT = 'Tab Item Content';
export const TILE = 'Tile';
export const VIDEO = 'Video';
export const WHITESPACE = 'Whitespace';
